import React from 'react';
import ReactDOM from 'react-dom/client';
import TrainingApp from './components/TrainingApp';
import './styles/TrainingApp.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <TrainingApp />
  </React.StrictMode>
);